export type BeginnerTimeUnit = 'SECONDS' | 'MILLISECONDS';

export interface BeginnerTimeValue {
  value: number;
  unit: BeginnerTimeUnit;
}

export const DEFAULT_BEGINNER_TIME: BeginnerTimeValue = {
  value: 1,
  unit: 'SECONDS',
};

export const BEGINNER_TIME_UNIT_OPTIONS: ReadonlyArray<[string, BeginnerTimeUnit]> = [
  ['Seconds', 'SECONDS'],
  ['Milliseconds', 'MILLISECONDS'],
];

export const BEGINNER_LED_ACTION_OPTIONS: ReadonlyArray<[string, string]> = [
  ['ON', 'ON'],
  ['OFF', 'OFF'],
  ['Toggle', 'TOGGLE'],
];

export const BEGINNER_PRESET_COLOR_OPTIONS: ReadonlyArray<[string, string]> = [
  ['Red', 'RED'],
  ['Green', 'GREEN'],
  ['Blue', 'BLUE'],
  ['Yellow', 'YELLOW'],
  ['Cyan', 'CYAN'],
  ['Magenta', 'MAGENTA'],
  ['White', 'WHITE'],
  ['Orange', 'ORANGE'],
  ['Purple', 'PURPLE'],
  ['Pink', 'PINK'],
  ['Custom', 'CUSTOM'],
];

export const BEGINNER_PIXEL_EFFECT_OPTIONS: ReadonlyArray<[string, string]> = [
  ['Rainbow', 'RAINBOW'],
  ['Color Wipe', 'COLOR_WIPE'],
  ['Chase', 'CHASE'],
  ['Theater Chase', 'THEATER_CHASE'],
  ['Blink', 'BLINK'],
  ['Breathe', 'BREATHE'],
  ['Sparkle', 'SPARKLE'],
  ['Scanner', 'SCANNER'],
  ['Comet', 'COMET'],
  ['Random Colors', 'RANDOM_COLORS'],
];

export const BEGINNER_CUSTOM_COLOR_FIELD_NAMES = ['RED', 'GREEN', 'BLUE'] as const;

export const BEGINNER_CUSTOM_COLOR_EXTENSION = 'beginner_custom_color_fields';

export function beginnerTimeToMilliseconds(time: BeginnerTimeValue): number {
  if (time.unit === 'MILLISECONDS') {
    return Math.max(0, Math.round(time.value));
  }
  return Math.max(0, Math.round(time.value * 1000));
}

export function formatBeginnerTimeLabel(time: BeginnerTimeValue): string {
  const unitLabel = time.unit === 'MILLISECONDS' ? 'Milliseconds' : 'Seconds';
  return `${time.value} ${unitLabel}`;
}

export function normalizeBeginnerTimeValue(
  value?: { value?: number | undefined; unit?: BeginnerTimeUnit | undefined } | null,
): BeginnerTimeValue {
  const numericValue = Number(value?.value ?? DEFAULT_BEGINNER_TIME.value);
  const unit = value?.unit === 'MILLISECONDS' ? 'MILLISECONDS' : 'SECONDS';
  return {
    value: Number.isFinite(numericValue) ? numericValue : DEFAULT_BEGINNER_TIME.value,
    unit,
  };
}
